<template>
    <div class="container-fluid">
        <Breadcrumb title="SpamTrap Domain List" button-url="spamDomainsCreate"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12 row-preloader" v-if="loading">
                <Preloader v-bind:class="{preloader: loading}"></Preloader>
            </div>
            <div class="col-12" v-else>
                <div class="card">
                    <div class="card-body">
                        <div class="form-inline">
                            <div class="form-group mb-2">
                                <button type="button" class="btn btn-success btn-rounded"
                                        @click="addSpamDomainsList"><i
                                        class="fas fa-upload"></i>
                                    Upload file with domains list
                                </button>
                            </div>
                            <div class="form-group mx-sm-3 mb-2" v-if="totalItems > 0">
                                <span>Total:
                                    <span class="label label-info">{{totalItems}}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group p-t-10">
                            <div class="progress" v-for="(uploadDomain,index) in uploadDomains" :key="index">
                                <div class="progress-bar bg-info"
                                     v-bind:style="{width: uploadDomain.completion}" role="progressbar"
                                     aria-valuenow="30" aria-valuemin="0" aria-valuemax="100">
                                    {{uploadDomain.completion}}
                                </div>
                            </div>
                        </div>
                        <div class="input-group form-group">
                            <input v-model="spamDomainSearch" type="text" class="form-control form-control-line"
                                   placeholder="Search domain">
                            <div class="input-group-append">
                                <button v-on:click="search" class="btn btn-info" type="button">Search</button>
                            </div>
                        </div>
                        <div v-if="spamDomainsList.length === 0">SpamTrap domains list is empty!</div>
                        <div v-else>
                            <div>
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Domain</th>
                                            <th>Actions</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(domain, index) in spamDomainsList" :key="index">
                                            <td class="align-middle">{{domain.id}}</td>
                                            <td class="align-middle">{{domain.domain}}</td>
                                            <td>
                                                <button type="button" class="btn btn-danger btn-sm m-r-15"
                                                        @click="deleteSpamDomain(domain.id)">
                                                    <i class="fa fa-minus-circle"></i> Delete
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <paginate v-if="pageCount > 1"
                                          v-model="page"
                                          :page-count="pageCount"
                                          :page-range="3"
                                          :margin-pages="2"
                                          :click-handler="getItems"
                                          :prev-text="'Prev'"
                                          :next-text="'Next'"
                                          :container-class="'pagination justify-content-center'"
                                          :page-class="'page-item'"
                                          :page-link-class="'page-link'"
                                          :prev-class="'page-item'"
                                          :prev-link-class="'page-link'"
                                          :next-class="'page-item'"
                                          :next-link-class="'page-link'">
                                </paginate>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from 'sweetalert2';
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import SpamDomainService from '../services/SpamDomainService';
    import config from '../config';
    import paginateMixin from '../mixins/paginate-mixin';
    import { mapGetters } from 'vuex';

    export default {
        name: 'SpamDomains',
        components: {
            Breadcrumb,
            Preloader
        },
        mixins: [ paginateMixin ],
        data() {
            return {
                spamDomainSearch: null,
                spamDomainsList: [],
                spamDomainFile: '',
                totalItems: 0,
                page: 1,
                perPage: paginateMixin.defaultPerPage,
                loading: false,
                jobs: [],
                uploadDomains: []
            }
        },
        mounted() {
            this.getItems(this.page = 1);
            this.uploadSpamDomainListProgress();
        },
        methods: {
            search: function () {
                this.getItems(this.page = 1);
            },
            uploadSpamDomainListProgress() {
                if (!this.mercureListen.hasOwnProperty(config.uploadSpamDomainProgressStatus)) {
                    let url = new URL(config.mercureHubUrl);
                    url.searchParams.append('topic', config.uploadSpamDomainProgressStatus);
                    let eventSource = new EventSource(url);
                    this.$store.commit('setListening', {[config.uploadSpamDomainProgressStatus]: eventSource});
                }
                this.mercureListen[config.uploadSpamDomainProgressStatus].onmessage = event => {
                    let data = JSON.parse(event.data);
                    if (data) {
                        let index = this.uploadDomains.findIndex(obj => obj.uuid === data.uuid);
                        if (index < 0) {
                            this.uploadDomains.push({
                                'uuid': data.uuid,
                                'completion': parseInt(data.completion) + '%'
                            });
                        } else {
                            this.uploadDomains[index].completion = parseInt(data.completion) + '%';
                            if (100 === parseInt(data.completion)) {
                                this.$snotify.success('File ' + data.filename + ' is processed!');
                                this.uploadDomains.splice(index, 1);
                                this.getItems(this.page);
                            }
                        }
                    }
                }
            },
            addSpamDomainsList() {
                Swal({
                    title: 'Add Spam Domains List',
                    html: '<input type="file" id="spam_domains" accept="text/csv" />',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        let domains = document.getElementById('spam_domains').files[0];
                        let formData = new FormData();
                        formData.append('spam_domains', domains);
                        return SpamDomainService.addSpamDomains(formData).then(response => {
                            if (response.status === 200) {
                                this.$snotify.warning('File processing started!');
                            }
                            if (response.data.error) {
                                Swal.showValidationMessage(
                                    `${response.data.error.spam_domains}`
                                );
                                return false;
                            }
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Added successfully!',
                            `We will notify you, when moderation process will be done.`,
                            'success'
                        )
                    }
                })
            },
            deleteSpamDomain(id) {
                Swal({
                    title: 'Are you sure you want to delete?',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return SpamDomainService.deleteSpamDomain(id).then((response) => {
                            if (response.status === 204) {
                                let index = this.spamDomainsList.findIndex(obj => obj.id === id);
                                this.spamDomainsList.splice(index, 1);
                            }
                        }).catch(error => {
                            Swal.showValidationMessage(
                                `Request failed: ${error}`
                            )
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Deleted successfully!',
                            `Spam trap domain has been deleted.`,
                            'success'
                        )
                    }
                })
            },
            getItems: function (pageNum) {
                this.loading = true;
                SpamDomainService.getSpamDomainsList(pageNum, this.perPage, this.spamDomainSearch).then(response => {
                    this.spamDomainsList = response.data['hydra:member'];
                    this.totalItems = response.data['hydra:totalItems'];
                    this.loading = false;
                }).catch(error => {
                    Swal({
                        type: 'error',
                        title: 'Oops...',
                        text: `${error}`,
                    });
                    this.loading = false;
                });
            }
        },
        computed: {
            pageCount: function () {
                return Math.ceil(this.totalItems / this.perPage);
            },
            ...mapGetters({mercureListen: 'listen'})
        }
    }
</script>

<style scoped>

</style>
